<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
        DatePicker
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            form: {
                id: '',
                income_type:1,
                currency_id: 1,
                change_date: '',
                exchange_rate: '',
                file: '',
                xml: '',
                client_id: '',
                name: '',
                tax_folio: '',
                date: '',
                folio: '',
                subtotal: '',
                iva: '',
                isr_ret: '',
                iva_ret: '',
                ieps: '',
                amount: '',
                discount: '',
                type_payment_id: '',
                company_id: '',
                bank_account_company_id: '',
                description: '',
                files: [],
            },
            fileName: '',
            xmlName: '',
            file: '',
            xml: '',
            files: [],
            send: false,
            load: false,
            block: false,
            companies:[],
        }
    },
    methods: {
        closedModal() {
            this.form.id = '';
            this.form.create_bill = false;
            this.form.currency_id = 1;
            this.form.change_date= '';
            this.form.exchange_rate= '';
            this.form.file = '';
            this.form.xml = '';
            this.form.client_id = '';
            this.form.name = '';
            this.form.tax_folio = '';
            this.form.date = '';
            this.form.folio = '';
            this.form.subtotal = '';
            this.form.iva = '';
            this.form.iva_ret = '';
            this.form.isr_ret = '';
            this.form.ieps = '';
            this.form.amount = '';
            this.form.discount = '';
            this.form.type_payment_id = '';
            this.form.company_id = '';
            this.form.bank_account_company_id= '';
            this.form.files = [];

            this.fileName = '';
            this.xmlName = '';
            this.file = '';
            this.xml = '';
            this.block = false;
            this.files = [];
            this.send = false;
            this.errors = {};

            this.$modal.hide('addIncome');
        },
        uploadFilesIncome(event) {
            let vm = this;

            let file = event.target.files[0];
            // let allowedImageTypes = ["image/jpeg", "image/gif", "image/png"];
            // if (!allowedImageTypes.includes(file.type)) {
            //     this.$swal({
            //         icon: 'error',
            //         title: 'Error en el tipo de archivo',
            //         text: 'Solo se acepta archivo tipo imagen',
            //     });
            // } else {
            vm.form.files.push(file);
            // console.log(vm.form.files);
            this.$forceUpdate();

            // }
        },
        createURL(file) {
            let link = URL.createObjectURL(file);
            return link;
        },
        calcTotal() {
            this.form.amount = this.form.subtotal + this.form.iva + this.form.ieps - this.form.isr_ret - this.form.iva_ret - this.form.discount;
        },
        async delImgUpload(pos) {
            let img = this.files[pos];
            let id = img.id;
            let _endpoint = '/other_incomes/deleted-documents';
            let form = {
                id: id
            };
            let { data } = await request.postMedia(_endpoint, form)
            if (data) {
                this.successNotification(data.message);
                this.files.splice(pos, 1);
            }

        },
        delImg(pos) {
            this.form.files.splice(pos, 1);
            this.successNotification('El archivo se elimino correctamente.');
        },
        catch_file(event) {
            if (event.target.files[0].type == "application/pdf") {
                this.form.file = event.target.files[0];
                this.fileName = event.target.files[0].name;
            } else {
                this.$swal({
                    icon: 'error',
                    title: 'Error tipo de archivo',
                    text: 'Solo se puede cargar archivos PDF',
                });
            }
        },
        catch_xml(event) {
            // console.log(event.target.files[0].type);
            if (event.target.files[0].type == "text/xml") {
                this.form.xml = event.target.files[0];
                this.xmlName = event.target.files[0].name;
                this.catchDataXML(event.target.files[0]);


            } else {
                this.$swal({
                    icon: 'error',
                    title: 'Error tipo de archivo',
                    text: 'Solo se puede cargar archivos XML',
                });
            }
        },
        async catchDataXML(file) {
            // console.log(file);
            const data_form = new FormData();
            data_form.append('xml', file);

            let _endpoint = `/income_bill_load_xml`;

            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    if (data.company_id) {
                        this.form.folio = data.Folio;
                        this.form.tax_folio = data.UUID;
                        this.form.subtotal = data.SubTotal;
                        this.form.iva = data.iva;
                        this.form.iva_ret = data.iva_ret;
                        this.form.discount = data.Descuento;
                        this.form.ieps = data.ieps;
                        this.form.isr_ret = data.isr_ret
                        if (data.currency_id) {
                            this.form.currency_id = data.currency_id;
                        }
                        if (data.bill_types_id) {
                            this.form.type_payment_id = data.type_payment_id;
                        }
                        if (data.company_id) {
                            this.form.company_id = data.company_id;
                        }
                        let DateIncome = this.moment(data.Fecha).format('YYYY-MM-DD');
                        this.form.date = DateIncome;

                        this.block = true;
                    }else{
                        this.form.xml = '';
                        this.xmlName = '';
                        this.$swal({
                            icon: 'error',
                            title: 'No se puede cargar la factura',
                            text: 'No se puede cargar porque la empresa no existe en el sistema'
                        });
                    }
                }
            } catch (error) {
                this.send = false;
                this.errors = {};
                if (error.response) {

                    this.errors = await this.errorNotification(error);
                }
            }

        },
        async saveIncome() {
            this.send = true;
            const data_form = new FormData();
            data_form.append('id', this.form.id);
            data_form.append('create_bill', this.form.create_bill);
            data_form.append('currency_id', this.form.currency_id);
            data_form.append('change_date',this.form.change_date);
            data_form.append('exchange_rate',this.form.exchange_rate);
            data_form.append('file', this.form.file);
            data_form.append('xml', this.form.xml);
            data_form.append('client_id', this.form.client_id);
            data_form.append('name', this.form.name);
            data_form.append('tax_folio', this.form.tax_folio  ? this.form.tax_folio : '');
            data_form.append('date', this.form.date);
            data_form.append('folio', this.form.folio??'');
            data_form.append('subtotal', this.form.subtotal);
            data_form.append('iva', this.form.iva);
            data_form.append('isr_ret', this.form.isr_ret);
            data_form.append('iva_ret', this.form.iva_ret);
            data_form.append('ieps', this.form.ieps??'');
            data_form.append('amount', this.form.amount);
            data_form.append('discount', this.form.discount??'');
            data_form.append('type_payment_id', this.form.type_payment_id);
            data_form.append('company_id', this.form.company_id);
            data_form.append('bank_account_company_id', this.form.bank_account_company_id);

            this.form.files.forEach(function (valor, index) {
                data_form.append('files[' + index + ']', valor);
            });


            let _endpoint = '/other_incomes';
            if (this.form.id != "") {
                data_form.append('_method', 'PUT');
                _endpoint = `/other_incomes/${this.form.id}`;
            }
            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    // console.log(data);
                    // this.users = data.data;
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-load-incomes');
                }
            } catch (error) {
                this.send = false;
                this.errors = {};
                if (error.response) {

                    this.errors = await this.errorNotification(error);
                }
            }
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    watch: {
        'catalogue.companies_buildings'(value) {
            this.companies = value;
        },
        'catalogue.companies_users'(value) {
            this.companies = value;
        },
        'form.company_id'(value) {
            this.catalogue.getBankAccountCompany(value);
        },
        'catalogue.bank_account_company'() {
            console.info(JSON.stringify(this.catalogue.bank_account_company))
        },
        'form.subtotal'() {
            this.calcTotal();
        },
        'form.discount'() {
            this.calcTotal();
        },
        'form.iva'() {
            this.calcTotal();
        },
        'form.isr_ret'() {
            this.calcTotal();
        },
        'form.iva_ret'() {
            this.calcTotal();
        },
        'form.ieps'() {
            this.calcTotal();
        }
    },
    mounted() {
        this.catalogue.get_type_payments_other_incomes();
        this.catalogue.getCurrencies();
		this.catalogue.get_users_profile(9);
        if (this.authUser.organization_charts_id != 1) {
            this.catalogue.get_companies_users(this.authUser.id);
        } else {
            this.catalogue.get_companies_buildings();
        }
    },
    created() {
        Event.$on("event-show-addIncome", async (income) => {
            if (income.id) {
                this.load = true;
                this.form.id = income.id;
                this.form.currency_id = income.currency_id;
                this.form.change_date= income.change_date;
                this.form.exchange_rate= income.exchange_rate;
                this.form.client_id = income.client_id;
                this.form.name = income.name;
                this.form.tax_folio = income.tax_folio ? income.tax_folio : '' ;
                this.form.date = income.date;
                this.form.folio = income.folio;
                this.form.subtotal = income.subtotal;
                this.form.iva = income.iva;
                this.form.iva_ret = income.iva_ret;
                this.form.isr_ret = income.isr_ret;
                this.form.ieps = income.ieps;
                this.form.amount = income.amount;
                this.form.discount = income.discount;
                this.form.type_payment_id = income.type_payment_id;
                this.form.company_id = income.company_id;
                this.form.bank_account_company_id = income.bank_account_company_id;
                this.form.files = [];

                if (income.file) {
                    this.file = income.file;
                }
                if (income.xml) {
                    this.xml = income.xml;
                }
                if (income.files) {
                    this.files = income.files;
                }
            }
            this.$modal.show('addIncome');
        });
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
}
</script>
<template>
    <modal name="addIncome" :width="'80%'" :maxHeight="300" :height="'auto'" v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <form @submit.prevent="saveIncome" method="post" enctype="multipart/form-data">
            <button :disabled="send" type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                    class="fa-solid fa-xmark"></i> </button>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Información Ingreso</h5>
            </div>
            <div class="modal-body">
                <div class="row">

                    <div class="col-md-12 mb-3">
                        <div class="row justify-content-start">
                            <div class="col-md-4" :style="form.currency_id == 2 ? 'padding-top: 30px' : ''">
                                <label v-for="(currency, index) in catalogue.currencies" :key="index" class="ml-1">
                                    {{ currency.name }} <input :disabled="!prop_edit" v-model="form.currency_id"
                                        :value="currency.id" type="radio" name="currency">
                                </label>
                            </div>

                            <!-- USD -->                          
                            <div class="col-md-4" v-if="form.currency_id == 2">
                                <label> Fecha tipo de cambio </label>
                                <date-picker v-model="form.change_date" :disabled="!prop_edit"
                                    valueType="format"></date-picker>
                                <div v-if="errors && errors.change_date" class="text-danger">{{ errors.change_date[0] }}</div>
                            </div>
                            <div class="col-md-4" v-if="form.currency_id == 2">
                                <label> Tipo de cambio </label>
                                <money :disabled="!prop_edit" class="form-control" v-model="form.exchange_rate"></money>
                                <div v-if="errors && errors.exchange_rate" class="text-danger">{{ errors.exchange_rate[0] }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-center">
                        <label>Tipo de ingreso:</label>
                        <select :disabled="!prop_edit" type="text" class="form-control" v-model="form.income_type">
                            <option value="1">Generar Factura</option>
                            <option value="2">Cargar Factura</option>
                            <option value="3">Sin Factura</option>
                        </select>
                        <span class="text-info text-sm"
                            v-if="companies.length == 0">No tienes empresas
                            relacionadas</span>
                        <div v-if="errors && errors.company_id" class="text-danger">{{ errors.company_id[0] }}</div>
                    </div>
                    <div class="col-md-6" v-if="form.income_type==2">
                        <label>PDF</label><br>
                        <div class="custom-file" :style="file != '' ? 'width: 87%' : 'width: 100%'">
                            <input :disabled="!prop_edit" type="file" class="custom-file-input"
                                :class="file != '' ? 'pr-5' : ''" id="customFile" ref="file" @change="catch_file">
                            <label class="custom-file-label text-left" for="customFile">{{ fileName }}</label>
                        </div>
                        <a :href="`${globalUrlFiles}${file}`" v-if="file != ''" target="_blank"
                            style="float: right; border-radius: 5px 0px 5px 0px;" class="btn btn-info"> <i
                                class="fa-regular fa-file-pdf"></i>
                        </a>
                        <br>
                        <div v-if="errors && errors.file" class="text-danger">{{ errors.file[0] }}</div>

                    </div>
                    <div class="col-md-6" v-if="form.income_type==2">
                        <label>XML</label><br>
                        <div class="custom-file" :style="xml != '' ? 'width: 87%' : 'width: 100%'">
                            <input :disabled="!prop_edit" type="file" id="fileXML" class="custom-file-input"
                                :class="xml != '' ? 'pr-5' : ''" ref="file" @change="catch_xml">
                            <label class="custom-file-label text-left" for="customFile">{{ xmlName }}</label>
                        </div>
                        <a :href="`${globalUrlFiles}${xml}`" v-if="xml != ''" target="_blank"
                            style="float: right; border-radius: 5px 0px 5px 0px;" class="btn btn-info"> <i
                                class="fa-regular fa-file"></i>
                        </a>
                        <br>
                        <div v-if="errors && errors.xml" class="text-danger">{{ errors.xml[0] }}</div>
                    </div>
                    <div class="col-md-6 mt-3">
                        <label>Empresa</label>
                        <select :disabled="!prop_edit" type="text" class="form-control" v-model="form.company_id">
                            <option v-for="(company, index) in companies" :value="company.id"
                                :key="index">
                                {{ company.name }}</option>
                        </select>
                        <span class="text-info text-sm"
                            v-if="companies.length == 0">No tienes empresas
                            relacionadas</span>
                        <div v-if="errors && errors.company_id" class="text-danger">{{ errors.company_id[0] }}</div>
                    </div>
                    <div class="col-md-6 mt-3" v-if="catalogue.bank_account_company.length">
                        <label>Cuenta de Dep&oacute;sito</label>
                        <select :disabled="!prop_edit" type="text" class="form-control" v-model="form.bank_account_company_id">
                            <option v-for="(account, index) in catalogue.bank_account_company" :value="account.id" :key="index">
                                {{ account.bank.name }} {{ account.number }}
                            </option>
                        </select>
                        <div v-if="errors && errors.bank_account_company_id" class="text-danger">{{ errors.bank_account_company_id[0] }}</div>
                    </div>
                    <div class="col-md-6 mt-3" v-else>
                    </div>
                    <div class="col-md-6">
                        <label>Cliente</label>
                        <select :disabled="!prop_edit" type="text" class="form-control" v-model="form.client_id">
                            <option v-for="(user, index) in catalogue.users_profile" :value="user.id" :key="index">
                                {{ user.name }} {{ user.last_name }}
                            </option>
                        </select>
                        <div v-if="errors && errors.client_id" class="text-danger">{{ errors.client_id[0] }}</div>
                    </div>
                    <div class="col-md-6 mt-6">
                        <label>Tipo de Pago</label>
                        <select :disabled="!prop_edit" type="text" class="form-control" v-model="form.type_payment_id">
                            <option v-for="(type, index) in catalogue.type_payments" :value="type.id" :key="index">{{ type.name }}</option>
                        </select>
                        <div v-if="errors && errors.type_payment_id" class="text-danger">{{ errors.type_payment_id[0] }}
                        </div>
                    </div>
                    <div class="col-md-9 mt-3">
                        <label>Concepto</label>
                        <input :disabled="!prop_edit" type="text" class="form-control" v-model="form.name">
                        <div v-if="errors && errors.name" class="text-danger">{{ errors.name[0] }}</div>
                    </div>
                    <div class="col-md-3 mt-3">
                        <label>Fecha de pago</label>
                        <date-picker v-model="form.date" :disabled="!prop_edit" required="required"
                            valueType="format"></date-picker>
                        <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                    </div>
                    <div class="col-md-6" v-if="form.income_type==2">
                        <label>Folio Fiscal</label>
                        <input :disabled="!prop_edit || authUser.organization_charts_id == 2 || block" type="text"
                            class="form-control" v-model="form.tax_folio">
                        <div v-if="errors && errors.tax_folio" class="text-danger">{{ errors.tax_folio[0] }}</div>
                    </div>
                    <div class="col-md-6" v-if="form.income_type==2">
                        <label>Folio</label>
                        <input :disabled="!prop_edit" type="text" class="form-control" v-model="form.folio">
                        <div v-if="errors && errors.folio" class="text-danger">{{ errors.folio[0] }}</div>
                    </div>
                    <div class="col-md-6 mt-3" v-if="form.income_type<=2">
                        <label>Subtotal</label>
                        <money :disabled="!prop_edit" class="form-control" v-model="form.subtotal"></money>
                        <div v-if="errors && errors.subtotal" class="text-danger">{{ errors.subtotal[0] }}</div>
                    </div>
                    <div class="col-md-6 mt-3" v-if="form.income_type<=2">
                        <label>IVA</label>
                        <money :disabled="!prop_edit" class="form-control" v-model="form.iva"></money>
                        <div v-if="errors && errors.iva" class="text-danger">{{ errors.iva[0] }}</div>
                    </div>
                    <div class="col-md-6 mt-3" v-if="form.income_type<=2">
                        <label>IEPS</label>
                        <money :disabled="!prop_edit" class="form-control" v-model="form.ieps"></money>
                        <div v-if="errors && errors.ieps" class="text-danger">{{ errors.ieps[0] }}</div>
                    </div>
                    <div class="col-md-6 mt-3" v-if="form.income_type<=2">
                        <label>ISR RET</label>
                        <money class="form-control" :disabled="!prop_edit" v-model="form.isr_ret"></money>
                        <div v-if="errors && errors.isr_ret" class="text-danger">{{ errors.isr_ret[0] }}</div>
                    </div>
                    <div class="col-md-6 mt-3" v-if="form.income_type<=2">
                        <label>IVA RET</label>
                        <money class="form-control" :disabled="!prop_edit" v-model="form.iva_ret"></money>
                        <div v-if="errors && errors.iva_ret" class="text-danger">{{ errors.iva_ret[0] }}</div>
                    </div>
                    <div class="col-md-3 mt-3">
                        <label>Descuento</label>
                        <money class="form-control" :disabled="!prop_edit" v-model="form.discount"></money>
                        <div v-if="errors && errors.discount" class="text-danger">{{ errors.discount[0] }}</div>
                    </div>
                    <div class="col-md-6 mt-3">
                        <label>Total</label>
                        <money :readonly="form.income_type<=2" class="form-control" v-model="form.amount"></money>
                        <div v-if="errors && errors.amount" class="text-danger">{{ errors.amount[0] }}</div>
                    </div>
                    <div class="col-12">
                        <hr>
                        <div class="row">
                            <div class="col-12 text-center">
                                <h3>Archivo adjuntos.</h3>
                                <p>Máximo 15 archivos.</p>
                                <div class="row mt-4 mb-4">
                                    <div class="col-12" v-if="(form.files.length + files.length) == 0">
                                        <i class="fa-solid fa-file fa-4x"></i>
                                        <p>Sin archivos adjuntos</p>
                                    </div>
                                    <div class="col-md-4 col-12 p-2" v-for="(fAdd, index_fAdd) in files"
                                        :key="index_fAdd" v-show="files.length > 0">
                                        <div class="card shadow">
                                            <button v-if="prop_edit" class="btn btn-sm btn-danger del" type="button"
                                                @click="delImgUpload(index_fAdd)">
                                                <i class="fa fa-trash"></i></button>
                                            <div class="card-body text-center">
                                                <a :href="`${globalUrlFiles}${fAdd.file}`" target="_blank">
                                                    <i class="fa fa-file fa-4x"></i>
                                                    <p>{{ fAdd.name }}</p>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 col-12 p-2" v-for="(img, index_img) in form.files"
                                        :key="index_img" v-show="form.files.length > 0">
                                        <div class="card shadow">
                                            <button v-if="prop_edit" class="btn btn-sm btn-danger del" type="button"
                                                @click="delImg(index_img)"><i class="fa fa-trash"></i></button>
                                            <div class="card-body text-center">
                                                <a :href="createURL(img)" target="_blank">
                                                    <i class="fa fa-file fa-4x"></i>
                                                    <p>{{ img.name }}</p>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="input-group mb-3"
                                    v-if="(form.files.length + files.length) <= 14 && prop_edit">
                                    <div class="custom-file" @change="uploadFilesIncome">
                                        <input type="file" class="custom-file-input" id="inputGroupFile03"
                                            aria-describedby="inputGroupFileAddon03">
                                        <label class="custom-file-label" for="inputGroupFile03">
                                            Subir Archivo
                                        </label>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>
                    <div class="col-md-12">
                        <hr>
                        <button v-if="prop_edit" :disabled="send" type="submit"
                            class="btn float-right btn-outline-success">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                            </span>
                            <span v-else>
                                <i class="fas fa-save"></i> Guardar
                            </span>
                        </button>
                        <button type="button" :disabled="send" @click="closedModal()"
                            class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>
<style scoped>
.image-upload>input {
    display: none;
}

.del {
    position: absolute;
    right: 0px;
    margin: 10px;
}
</style>